module.exports = __webpack_public_path__ + "static/media/lake-louise.5aa9dd89.jpg";